import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateCcw = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6892_8493)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.16699 2.66699V6.66699H5.16699",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.84033 9.99964C3.27259 11.2266 4.09188 12.2798 5.17476 13.0006C6.25764 13.7214 7.54545 14.0707 8.84414 13.996C10.1428 13.9212 11.382 13.4264 12.3751 12.5861C13.3681 11.7459 14.0612 10.6056 14.3498 9.33722C14.6385 8.06881 14.5071 6.74094 13.9754 5.55371C13.4438 4.36647 12.5407 3.38417 11.4022 2.75482C10.2638 2.12546 8.95159 1.88315 7.66344 2.06438C6.37529 2.24562 5.18093 2.84059 4.26033 3.75964L1.16699 6.66631",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6892_8493",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgRotateCcw;
